var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"90%","margin":"0PX AUTO"}},[(_vm.datalst && _vm.datalst.length > 0)?_c('van-row',_vm._l((_vm.datalst),function(item,index){return _c('van-col',{key:index,attrs:{"span":"6"}},[_c('img',{staticStyle:{"width":"70%"},attrs:{"src":item.logo}})])}),1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }